export const FAIL_FINISH_PROJECT =
  'Algo inesperado aconteceu ao finalizar o projeto, tente novamente mais tarde.'

export const FAIL_DELETE_CLIENT =
  'Algo inesperado aconteceu ao excluir o cliente, tente novamente mais tarde.'
